
    import { NavLink } from "react-router-dom";
    const MENU = [{
    label: "uniform变量",
    key: "uniform变量",
    children: [{
label: <NavLink to="/uniform变量/详解uniform全局变量">详解uniform全局变量</NavLink>,
key: "/uniform变量/详解uniform全局变量",
},
],
  },{
    label: "二维",
    key: "二维",
    children: [{
label: <NavLink to="/二维/平移">平移</NavLink>,
key: "/二维/平移",
},
{
label: <NavLink to="/二维/旋转">旋转</NavLink>,
key: "/二维/旋转",
},
],
  },{
    label: "坐标系统",
    key: "坐标系统",
    children: [{
label: <NavLink to="/坐标系统/画布尺寸及视口">画布尺寸及视口</NavLink>,
key: "/坐标系统/画布尺寸及视口",
},
{
label: <NavLink to="/坐标系统/纹理坐标">纹理坐标</NavLink>,
key: "/坐标系统/纹理坐标",
},
{
label: <NavLink to="/坐标系统/齐次坐标">齐次坐标</NavLink>,
key: "/坐标系统/齐次坐标",
},
],
  },{
    label: "基础知识",
    key: "基础知识",
    children: [{
label: <NavLink to="/基础知识/webgl流程线及基本概念">webgl流程线及基本概念</NavLink>,
key: "/基础知识/webgl流程线及基本概念",
},
{
label: <NavLink to="/基础知识/调试工具">调试工具</NavLink>,
key: "/基础知识/调试工具",
},
{
label: <NavLink to="/基础知识/颜色缓冲区简介">颜色缓冲区简介</NavLink>,
key: "/基础知识/颜色缓冲区简介",
},
],
  },{
    label: "属性和缓冲",
    key: "属性和缓冲",
    children: [{
label: <NavLink to="/属性和缓冲/size和属性默认值">size和属性默认值</NavLink>,
key: "/属性和缓冲/size和属性默认值",
},
{
label: <NavLink to="/属性和缓冲/属性在WebGL内部的表示">属性在WebGL内部的表示</NavLink>,
key: "/属性和缓冲/属性在WebGL内部的表示",
},
{
label: <NavLink to="/属性和缓冲/属性的两种赋值方式">属性的两种赋值方式</NavLink>,
key: "/属性和缓冲/属性的两种赋值方式",
},
{
label: <NavLink to="/属性和缓冲/详解vertexAttribPointer">详解vertexAttribPointer</NavLink>,
key: "/属性和缓冲/详解vertexAttribPointer",
},
{
label: <NavLink to="/属性和缓冲/通过缓冲传递坐标和颜色值">通过缓冲传递坐标和颜色值</NavLink>,
key: "/属性和缓冲/通过缓冲传递坐标和颜色值",
},
],
  },{
    label: "纹理",
    key: "纹理",
    children: [{
label: <NavLink to="/纹理/texImage2D详解">texImage2D详解</NavLink>,
key: "/纹理/texImage2D详解",
},
{
label: <NavLink to="/纹理/为什么纹理是颠倒的">为什么纹理是颠倒的</NavLink>,
key: "/纹理/为什么纹理是颠倒的",
},
{
label: <NavLink to="/纹理/纹理单元及底层表示">纹理单元及底层表示</NavLink>,
key: "/纹理/纹理单元及底层表示",
},
{
label: <NavLink to="/纹理/纹理尺寸">纹理尺寸</NavLink>,
key: "/纹理/纹理尺寸",
},
{
label: <NavLink to="/纹理/纹理的简单使用">纹理的简单使用</NavLink>,
key: "/纹理/纹理的简单使用",
},
],
  },];
    export default MENU;
    